
<div class="room-container  mt-4"  [@fadeInOnEnter] [@fadeOutOnLeave] [class.is-multi-room]="isMultiRoom">
    <div class="row">
        <div class="col-12 col-md-6">

            <app-image-gallery1 [roomCode]="roomData.roomrates[0].room.roomCode" [hotelCode]="avService.getSearchParams()?.hotelCode"></app-image-gallery1>

            <!-- <app-image-gallery2 [roomCode]="roomData.room.roomCode"></app-image-gallery2> -->

        </div>
        <div class="col-12 col-md-6">
            <div class="room-data">

                <div class="row">
                    <div class="col-10">
                        <h2 class="room-name" [attr.data-testid]="'room-title'">{{roomData.roomrates[0].room.pim?.name ?? roomData.roomrates[0].room.roomName}}</h2>
                    </div>

                    @if (avService.getCategoryName(roomData.roomrates[0].room)) {

                        <div class="col-2">
                            <div class="room-category-tag">{{avService.getCategoryName(roomData.roomrates[0].room)}}</div>
                        </div>
                    }

                </div>
                @if (fewLeft) {
                    <div class="few-left-info">
                        <span class="material-symbols-outlined">
                            notifications_active
                        </span>
                        @if (roomData.roomrates[0].room.numberOfRoomsAvailable == 1){
                            {{"av.fewLeftNoticeSingle"|translate:{value: roomData.roomrates[0].room.numberOfRoomsAvailable} }}
                        }
                        @else {
                            {{"av.fewLeftNotice"|translate:{value: roomData.roomrates[0].room.numberOfRoomsAvailable} }}
                        }
                    </div>
                }


                <div class="amenities">
                    @for (amenity of roomData.roomrates[0].room.pim?.amenities; track $index) {
                        <div  class="amenity">
                            @if (amenity == 'tv') {
                                <span class="amenity-icon">
                                    <span class="material-symbols-outlined">tv</span>
                                </span>
                                <span class="amenity-text">{{"av.Television"|translate}}</span>
                            }
                            @if (amenity == 'kingbed') {
                                <span class="amenity-icon">
                                    <span class="material-symbols-outlined">king_bed</span>
                                </span>
                                <span class="amenity-text">{{"av.KingBed"|translate}}</span>
                            }
                            @if (amenity == 'twin') {
                                <span class="amenity-icon">
                                    <span class="material-symbols-outlined">single_bed</span>
                                    <span class="material-symbols-outlined">single_bed</span>
                                </span>
                                <span class="amenity-text">{{"av.TwoSingleBeds"|translate}}</span>
                            }
                            @if (amenity == 'extrabed') {
                                <span class="amenity-icon">
                                    <span class="material-symbols-outlined">single_bed</span>
                                </span>
                                <span class="amenity-text">{{"av.ExtraBed"|translate}}</span>
                            }
                            @if (amenity == 'ac') {
                                <span class="amenity-icon">
                                    <span class="material-symbols-outlined">ac_unit</span>
                                </span>
                                <span class="amenity-text">{{"av.AC"|translate}}</span>
                            }
                        </div>
                    }
                </div>
                <!-- <div class="selling-points">
                    @for (sp of roomData.room.sellingPoints; track $index) {
                        <div  class="selling-point">
                            <span class="sp-text" [innerHTML]="sp.replace('sqm', 'm<sup>2</sup>')"></span>
                        </div>
                    }
                </div> -->
                <div class="room-description">
                    <app-truncated-text [text]="roomData.roomrates[0].room.pim?.shortDescription" [truncateHeight]="settings.get('availability.roomDescriptionMaxHeight')" [attr.data-testid]="'room-description'"></app-truncated-text>

                    <p-button [outlined]="true" size="small" (click)="readMore()" [attr.data-testid]="'read-more-about-room'">{{ readMoreLabel ?? ('av.ReadMore'|translate) }} <span class="material-symbols-outlined">
                        open_in_full
                        </span> </p-button>
                </div>


                @if (roomData.roomrates) {
                    @for (rate of roomData.roomrates; track $index) {
                        @if ($index < 3) {
                            <app-availability-room-1-rate [rate]="rate"  (onSelect)="selectRoomRate(rate)"></app-availability-room-1-rate>
                        }
                    }
                    @if (roomData.roomrates.length > settings.get("availability.maxVisibleRates")) {
                        <div class="d-flex justify-content-end">
                            <p-button [outlined]="true" (click)="openMoreRates();" [attr.data-testid]="'open-more-rates'">{{"av.showMoreRates"|translate}}</p-button>
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</div>

